import { useImmutableState } from '../state';
import { getProductLineItems } from './orderUtils';

const useOrderPresentation = () => {
  const { appMode, order } = useImmutableState();

  if (order == null) {
    // Note: This should never happen, but we want to be sure
    throw new Error(
      'Cannot create order presentation, order is null or undefined',
    );
  }

  const { id: orderId, campaign } = order;
  const productLineItems = getProductLineItems(order);

  if (productLineItems == null) {
    throw new Error(`Order ${orderId} has no line items`);
  }

  const lineItemPresentations = productLineItems.map((lineItem, idx) => {
    const { discount, price, quantity, product, id } = lineItem;
    const showPrice = appMode === 'purchase';

    let headline;
    let description;
    let terms;
    let buttonText;
    let updatedPrice;
    let unitPrice;

    if (appMode === 'redeemGift') {
      headline = product.redeemHeadline;
      description = product.redeemInfoText;
      terms = product.redeemPaymentTerms;
      buttonText = product.redeemButtonText;
      updatedPrice = false;
      unitPrice = 0;
    } else {
      if (idx > 0 || campaign == null) {
        headline = product.headline;
        description = product.infoText;
        terms = product.paymentTerms;
        buttonText = product.buttonText;
      } else {
        headline = campaign.headline;
        description = campaign.infoText;
        terms = campaign.terms;
        buttonText = campaign.buttonText;
      }

      updatedPrice = price !== product.price;
      // For fixed price campaigns we will show the summed price as
      // the unit price. We are using quantity for how many months
      // a fixed price campaign will span.
      unitPrice = campaign?.type === 'fixedPrice' ? quantity * price : price;
    }

    return {
      id,
      headline,
      description,
      terms,
      buttonText,
      showPrice,
      updatedPrice,
      unitPrice,
      discount,
      quantity,
      maxQuantity: product.maxQuantity,
    };
  });

  return lineItemPresentations;
};

export default useOrderPresentation;
